import { render, staticRenderFns } from "./v_Player.vue?vue&type=template&id=3c11ce41&scoped=true&"
import script from "./v_Player.vue?vue&type=script&lang=js&"
export * from "./v_Player.vue?vue&type=script&lang=js&"
import style0 from "./v_Player.vue?vue&type=style&index=0&id=3c11ce41&prod&scoped=true&class=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c11ce41",
  null
  
)

export default component.exports